import PolicyLayout from './PolicyLayout';

export default function RefundPolicyPage() {
  return (
    <PolicyLayout
      title="Refund & Return Policy"
      subtitle="Our policy on refunds and returns for DotCall services."
    >
      <div className="rounded-xl bg-amber-600/[0.08] border border-amber-500/25 p-5 mb-6">
        <p style={{ marginBottom: 0, color: 'rgba(255,255,255,0.9)', fontWeight: 500 }}>
          <strong>Please note:</strong> DotCall does <strong>not</strong> provide any refunds.
        </p>
      </div>

      <h2>1. No Refund Policy</h2>
      <p>
        DotCall is a Software-as-a-Service (SaaS) platform delivering AI voice agents and related digital
        services. All sales, subscription fees, wallet top-ups, and one-time charges paid to DotCall are
        <strong> final and non-refundable</strong>. Once a payment has been processed and credited to your
        account or wallet, it cannot be refunded, returned, or reversed under any circumstances.
      </p>

      <h2>2. Why We Don't Offer Refunds</h2>
      <ul>
        <li>DotCall is a digital service; once access is provisioned, usage cannot be "returned".</li>
        <li>Every call incurs real-time costs with our telephony (Twilio) and AI (OpenAI) providers that we
          pay on your behalf regardless of the outcome of the call.</li>
        <li>We offer a generous <strong>Free plan with 10 minutes of lifetime usage</strong> plus a public
          landing-page demo call so you can fully evaluate the platform <em>before</em> paying.</li>
      </ul>

      <h2>3. No Returns</h2>
      <p>Since DotCall does not sell physical products, there are no returns. All deliverables are digital and
        consumed in real time.</p>

      <h2>4. Wallet Balance</h2>
      <p>Amounts added to your DotCall wallet can only be used for platform services (call minutes, premium
        model usage, add-on features). Wallet balances <strong>cannot be withdrawn, transferred, or converted
        to cash</strong>. Wallet balances do not expire as long as your account remains active.</p>

      <h2>5. Cancellation of Subscription</h2>
      <p>You may cancel your Premium or Enterprise subscription at any time from your dashboard settings.
        Cancellation will stop future renewals. You will continue to have access to the paid features until the
        end of the current billing cycle, after which the account will revert to the Free plan. <strong>No
        partial or pro-rated refund</strong> is issued for the unused portion of the current billing cycle.</p>

      <h2>6. Failed or Duplicate Payments</h2>
      <p>In the rare case that your payment gateway charges you twice for a single transaction, or a payment is
        debited but not credited to your DotCall account due to a technical error, please contact us within 7
        days with your payment reference. We will verify with our payment partner (Razorpay) and, if a
        duplicate or failed-but-debited transaction is confirmed, the amount will be credited to your DotCall
        wallet. Bank reversals are governed by the payment partner's policies.</p>

      <h2>7. Contact</h2>
      <p>For questions about billing, please contact us at <strong>support@dotcall.io</strong> or
        <strong> +91 88798 51335</strong>. By making any payment to DotCall, you acknowledge that you have
        read, understood, and agree to this No-Refund Policy.</p>
    </PolicyLayout>
  );
}
